import React, { useState } from 'react';
import { Menu, X, ShoppingCart, User } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Header.css';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';

const Header = ({ onNavigate, onCartClick }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { getCartCount } = useCart();
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const cartCount = getCartCount();

  const scrollToSection = (sectionId) => {
    // If not on homepage, navigate to homepage first
    if (location.pathname !== '/') {
      navigate('/');
      setIsMobileMenuOpen(false);
      // Wait for navigation then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      setIsMobileMenuOpen(false);
    }
  };

  const handleLogoClick = () => {
    if (location.pathname === '/') {
      // If already on homepage, scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Navigate to homepage
      navigate('/');
    }
  };

  return (
    <header className="nav-header">
      <div className="nav-container">
        <div className="nav-logo-link" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <div className="nav-logo">
            <img src="/logo.svg" alt="House of Microgreens" className="logo-image" />
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="nav-links desktop-nav">
          <button className="nav-link" onClick={() => scrollToSection('benefits')}>Benefits</button>
          <button className="nav-link" onClick={() => scrollToSection('subscription')}>Subscription</button>
          <button className="nav-link" onClick={() => scrollToSection('varieties')}>Varieties</button>
          <Link to="/blog" className="nav-link">Blog</Link>
          <Link to="/about" className="nav-link">About</Link>
          <button className="nav-link" onClick={() => scrollToSection('contact')}>Contact</button>
        </nav>

        <div className="nav-actions">
          <button className="cart-btn" onClick={onCartClick} aria-label="Shopping cart">
            <ShoppingCart size={22} />
            {cartCount > 0 && (
              <span className="cart-count">{cartCount}</span>
            )}
          </button>
          
          {isAuthenticated ? (
            <Link to="/dashboard" className="btn-dashboard">
              <User size={18} />
              <span>My Account</span>
            </Link>
          ) : (
            <Link to="/login" className="btn-login-header">
              Login
            </Link>
          )}
          
          <button className="btn-primary subscribe-btn" onClick={() => scrollToSection('subscription')}>
            Subscribe Now
          </button>
          <button className="mobile-menu-btn" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          {isAuthenticated ? (
            <Link to="/dashboard" className="nav-link mobile mobile-auth-btn" onClick={() => setIsMobileMenuOpen(false)}>
              <User size={18} />
              <span>My Account</span>
            </Link>
          ) : (
            <Link to="/login" className="nav-link mobile mobile-auth-btn" onClick={() => setIsMobileMenuOpen(false)}>
              Login / Sign Up
            </Link>
          )}
          <button className="nav-link mobile" onClick={() => scrollToSection('benefits')}>Benefits</button>
          <button className="nav-link mobile" onClick={() => scrollToSection('subscription')}>Subscription</button>
          <button className="nav-link mobile" onClick={() => scrollToSection('varieties')}>Varieties</button>
          <Link to="/blog" className="nav-link mobile" onClick={() => setIsMobileMenuOpen(false)}>Blog</Link>
          <Link to="/about" className="nav-link mobile" onClick={() => setIsMobileMenuOpen(false)}>About</Link>
          <button className="nav-link mobile" onClick={() => scrollToSection('contact')}>Contact</button>
        </div>
      )}
    </header>
  );
};

export default Header;
